// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___3Nq1I","headerBackBtn":"style__headerBackBtn___1D817","headerBackBtn_memorial":"style__headerBackBtn_memorial___JF3_h","image":"style__image___3Njc7","doneControlsContainer":"style__doneControlsContainer___3Ykm1","doneControls":"style__doneControls___31so_","BigPlayButton":"style__BigPlayButton___hzlRN"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stickers/ui/screens/new-sticker-media-video/style.css
// module id = 1331
// module chunks = 0